import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let cachedSettings = null;
let cachePromise = null;
const subscribers = new Set();

const notifySubscribers = (newSettings) => {
  subscribers.forEach((cb) => cb(newSettings));
};

export const invalidateSettings = () => {
  cachedSettings = null;
  cachePromise = null;
};

const fetchSettingsCached = async () => {
  if (cachedSettings) return cachedSettings;
  if (cachePromise) return cachePromise;
  cachePromise = axios
    .get(`${BACKEND_URL}/api/settings`, { withCredentials: true })
    .then(({ data }) => {
      cachedSettings = data;
      cachePromise = null;
      notifySubscribers(data);
      return data;
    })
    .catch((err) => {
      cachePromise = null;
      throw err;
    });
  return cachePromise;
};

export const useSettings = () => {
  const [settings, setSettings] = useState(cachedSettings);
  const [loading, setLoading] = useState(!cachedSettings);

  useEffect(() => {
    let mounted = true;
    if (cachedSettings) {
      setSettings(cachedSettings);
      setLoading(false);
    } else {
      fetchSettingsCached()
        .then((data) => {
          if (mounted) {
            setSettings(data);
            setLoading(false);
          }
        })
        .catch(() => {
          if (mounted) setLoading(false);
        });
    }
    const unsub = (newSettings) => {
      if (mounted) setSettings(newSettings);
    };
    subscribers.add(unsub);
    return () => {
      mounted = false;
      subscribers.delete(unsub);
    };
  }, []);

  return { settings, loading };
};
